// @flow
import React from 'react'
import type { Node } from 'react'
import classnames from 'classnames'

type PropsT = {
  className?: string,
  tooltipId?: string,
  icons: Node,
  onClick?: Function
}

const HeaderActionItem = ({ className, tooltipId, icons, onClick = () => {} }: PropsT) => {
  const tooltipProps = tooltipId
    ? {
        'data-tip': true,
        'data-for': tooltipId
      }
    : {}
  return (
    <button
      {...tooltipProps}
      type='button'
      className={classnames('HeaderActionItem', className)}
      onClick={onClick}
    >
      <div className='HeaderActionItem__icon'>
        {icons}
      </div>
    </button>
  )
}

export default HeaderActionItem
